import { useEffect, useRef, useState } from "react";
import {
  collectAttributionMeta,
  buildSessionContext,
} from "../SurveyManagement/surveyService";

/**
 * Capture attribution at widget open and merge parent-page context in embed mode.
 */
export function useSurveySessionContext(embed) {
  const widgetOpenedAtMs = useRef(Date.now());
  const [attribution, setAttribution] = useState(() =>
    typeof window !== "undefined" ? collectAttributionMeta() : {}
  );

  useEffect(() => {
    if (!embed || typeof window === "undefined") return undefined;

    const onMessage = (event) => {
      const data = event && event.data;
      if (!data || typeof data !== "object") return;
      if (data.pivonyFeedback !== "context") return;
      setAttribution((prev) => ({
        ...prev,
        page_url: data.page_url || prev.page_url,
        referrer_url:
          data.referrer_url !== undefined ? data.referrer_url : prev.referrer_url,
        utm_params: data.utm_params || prev.utm_params,
        time_on_page_before_trigger_seconds:
          data.time_on_page_before_trigger_seconds ??
          prev.time_on_page_before_trigger_seconds,
      }));
    };

    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [embed]);

  const getSessionContext = () =>
    buildSessionContext({
      widgetOpenedAtMs: widgetOpenedAtMs.current,
      attribution,
      timeOnPageBeforeTriggerSeconds: attribution.time_on_page_before_trigger_seconds,
    });

  return { getSessionContext };
}
